export const ROCADEIRA = {
    Codigo: 13,
    Nome: 'Roçadeira',
    Modelo: 'GH-1000',
    Capa: null, 
    Home: true,
    Imagens: [
        {
            Capa: true,
            Ativo: true,
            Url: "assets/IPB/Produtos/Rocadeira/rocadeira_1.png"
        }
        , {
            Url: "assets/IPB/Produtos/Rocadeira/rocadeira_2.png"
        }
        , {
            Url: "assets/IPB/Produtos/Rocadeira/rocadeira_3.png"
        }
        , {
            Url: "assets/IPB/Produtos/Rocadeira/rocadeira_4.png"
        }
    ],
    Detalhes: [
        `Cardan com embreagem`,
        `Proteção traseira`,
        `Giro Livre`,
        `Roda reguladora de altura`,
        `Transmissão INPEL`,
        `OPCIONAL: Regulagem lateral de altura e kit corrente`
    ],
    Modelos: [
        { Modelo: `R-130`, Detalhes: `Largura de corte 1,30m` },
        { Modelo: `R-160`, Detalhes: `Largura de corte 1,60m` },
        { Modelo: `R-180`, Detalhes: `Largura de corte 1,80m` },
        { Modelo: `R-200`, Detalhes: `Largura de corte 2,00m` }
    ]
}